
import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SocialMedia from './SocialMedia';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Social Media Automation';

export default async function action({ store }) {

    // Check Authentication
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }

    // Reuse site settings privilege or create a new one. 
    // For now using 'siteSettings' privilege to avoid complexity.
    // if (!restrictUrls('/siteadmin/settings/social', adminPrivileges, privileges)) {
    //   return { redirect: '/siteadmin' };
    // }

    return {
        title,
        component: <AdminLayout><SocialMedia title={title} /></AdminLayout>,
    };
};
